var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4353 1.72792C12.8033 0.757361 14.1959 0.757361 14.565 1.72792L16.9454 8.32172C17.0284 8.53652 17.1747 8.72108 17.3648 8.85104C17.5549 8.981 17.7799 9.05025 18.0102 9.04964H23.86C24.941 9.04964 25.4125 10.3951 24.5626 11.054L20.3998 14.7994C20.2134 14.9427 20.0771 15.1415 20.0106 15.3671C19.944 15.5927 19.9507 15.8335 20.0295 16.0551L21.5498 22.4983C21.9201 23.5332 20.7218 24.4222 19.8157 23.7851L14.1614 20.1972C13.9677 20.0612 13.7368 19.9881 13.5001 19.9881C13.2635 19.9881 13.0326 20.0612 12.8389 20.1972L7.18462 23.7851C6.27961 24.4222 5.08021 23.5321 5.4505 22.4983L6.97073 16.0551C7.04959 15.8335 7.05624 15.5927 6.98971 15.3671C6.92319 15.1415 6.78692 14.9427 6.60045 14.7994L2.43763 11.054C1.58667 10.3951 2.06045 9.04964 3.1391 9.04964H8.98889C9.21921 9.05041 9.44435 8.98122 9.63449 8.85124C9.82464 8.72126 9.97084 8.53661 10.0537 8.32172L12.4341 1.72792H12.4353Z",
    stroke: "#02E2FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityMobile);
export default __webpack_public_path__ + "static/media/qualityMobile.33da4f2b0f0b1b82961d9d4e8c3c4b5b.svg";
export { ForwardRef as ReactComponent };